var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIdCardRegular(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-id-card-regular",
    clipPath: "url(#clip0_1181_25432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 14.25C6.389 14.25 4.875 12.736 4.875 10.875C4.875 9.014 6.389 7.5 8.25 7.5C10.111 7.5 11.625 9.014 11.625 10.875C11.625 12.736 10.111 14.25 8.25 14.25ZM8.25 9C7.216 9 6.375 9.841 6.375 10.875C6.375 11.909 7.216 12.75 8.25 12.75C9.284 12.75 10.125 11.909 10.125 10.875C10.125 9.841 9.284 9 8.25 9Z",
    fill: "#F0563A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 19.5C3.336 19.5 3 19.164 3 18.75C3 15.855 5.355 13.5 8.25 13.5C11.145 13.5 13.5 15.855 13.5 18.75C13.5 19.164 13.164 19.5 12.75 19.5H3.75ZM11.924 18C11.572 16.288 10.032 15 8.25 15C6.468 15 4.928 16.288 4.576 18H11.924Z",
    fill: "#F0563A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12C13.836 12 13.5 11.664 13.5 11.25C13.5 10.836 13.836 10.5 14.25 10.5H18.75C19.164 10.5 19.5 10.836 19.5 11.25C19.5 11.664 19.164 12 18.75 12H14.25Z",
    fill: "#F0563A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 15C13.836 15 13.5 14.664 13.5 14.25C13.5 13.836 13.836 13.5 14.25 13.5H20.25C20.664 13.5 21 13.836 21 14.25C21 14.664 20.664 15 20.25 15H14.25Z",
    fill: "#F0563A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 24C18.336 24 18 23.664 18 23.25C18 22.836 17.664 22.5 17.25 22.5C16.836 22.5 16.5 22.836 16.5 23.25C16.5 23.664 16.164 24 15.75 24H8.25C7.836 24 7.5 23.664 7.5 23.25C7.5 22.836 7.164 22.5 6.75 22.5C6.336 22.5 6 22.836 6 23.25C6 23.664 5.664 24 5.25 24H2.25C1.009 24 0 22.991 0 21.75V6.75C0 5.509 1.009 4.5 2.25 4.5H21.75C22.991 4.5 24 5.509 24 6.75V21.75C24 22.991 22.991 24 21.75 24H18.75ZM21.75 22.5C22.164 22.5 22.5 22.164 22.5 21.75V6.75C22.5 6.336 22.164 6 21.75 6H2.25C1.836 6 1.5 6.336 1.5 6.75V21.75C1.5 22.164 1.836 22.5 2.25 22.5H4.629C4.942 21.615 5.79 21 6.75 21C7.71 21 8.558 21.615 8.871 22.5H15.128C15.442 21.615 16.29 21 17.25 21C18.21 21 19.058 21.615 19.372 22.5H21.75Z",
    fill: "#F0563A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 3C22.836 3 22.5 2.664 22.5 2.25C22.5 1.836 22.164 1.5 21.75 1.5H2.25C1.836 1.5 1.5 1.836 1.5 2.25C1.5 2.664 1.164 3 0.75 3C0.336 3 0 2.664 0 2.25C0 1.009 1.009 0 2.25 0H21.75C22.991 0 24 1.009 24 2.25C24 2.664 23.664 3 23.25 3Z",
    fill: "#F0563A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1181_25432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdCardRegular);
export default __webpack_public_path__ + "static/media/icon-id-card-regular.8b89561ae3a780379fbb765307595558.svg";
export { ForwardRef as ReactComponent };